import React from 'react'
import { Tooltip } from '@mui/material'
import { GridActionsCellItem } from '@mui/x-data-grid'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'

export default function GridDeleteRowAction({ label = 'Delete row', disabled, onClick, ...props }) {
    return (
        <GridActionsCellItem
            {...props}
            label={label}
            color='error'
            icon={
                <Tooltip title='Delete row'>
                    <DeleteOutlineIcon fontSize='small' />
                </Tooltip>
            }
            disabled={disabled}
            onClick={(event) => {
                event.stopPropagation()
                onClick()
            }}
        />
    )
}
